import React from 'react';
import { Redirect } from "react-router-dom";

import DetailRedeem from 'component/campaign/DetailRedeem';
import AboutNavigator from 'component/common/AboutNavigator';
import UserNavigator from 'component/common/UserNavigator';
import CouponDetail from 'component/coupon/CouponDetail';
import CouponSelectStore from 'component/coupon/CouponSelectStore';
import UseCoupon from 'component/coupon/UseCoupon';
import BrowserNotSupport from 'component/error/BrowserNotSupport';
import Login from 'component/login/Login';
import ActivityLogMobile from 'component/profile/ActivityLogMobile';
import LevelBenefitMobile from 'component/profile/LevelBenefitMobile';
import LevelRuleMobile from 'component/profile/LevelRuleMobile';
import RewardStatusMobile from 'component/profile/RewardStatusMobile';
import TransactionHistoryListMobile from 'component/profile/TransactionHistoryListMobile';
import UseCashDollar from 'component/profile/UseCashDollar';
import CampaignDetail from 'container/CampaignDetail';
import CreateRewardClaim from 'container/CreateRewardClaim';
import EglFamilyWebview from 'container/EglFamilyWebview';
import EventRegisterResult from 'container/EventRegisterResult';
import Home from 'container/Home';
import Inbox from 'container/Inbox';
import InboxDetailMobile from 'container/InboxDetailMobile';
import Offer from 'container/Offer';
import ReachLimitDetailMobile from 'container/ReachLimitDetailMobile';
import StoreDetail from 'container/StoreDetail';
import TransactionDetailMobile from 'container/TransactionDetailMobile';
import TransactionHistoryDetailMobile from 'container/TransactionHistoryDetailMobile';
import TransactionList from 'container/TransactionList';
import UnsubscribeEmail from 'container/UnsubscribeEmail';
import NoWebappMemberAccountCompletePage from 'component/common/NoWebappHappyDownloadPage'
import RedeemGiftCard from 'container/RedeemGiftCard';
import StoreList from "container/StoreList";
import CouponList from "component/coupon/CouponList";
import MyCard from "container/MyCard";
import MyProfile from "container/MyProfile";
import MyAccount from "container/MyAccount";
import OfferList from "component/offer/OfferList";
import LanguagesSelection from 'container/LanguagesSelection';
import AboutMobile from 'container/AboutMobile';

import { BottomTabRouteType } from "utils/CustomEnums";
import { bottomNavConfig } from 'frontend_common/ThemeConfig'
import { detectIsMobileByScreenWidth } from 'utils/ScreenUtils';

const getWeChatTitleFromConfig = (routeType) => {
    return bottomNavConfig?.[routeType]?.name || ''
}

export const BASIC_WEBAPP_ROUTES = [
    {
        path: '/home',
        component: Home,
        isAuthProtected: false,
        weChatTitle: getWeChatTitleFromConfig(BottomTabRouteType.BOTTOM_TAB_HOME),
    },
    {
        path: '/store',
        component: StoreList,
        weChatTitle: getWeChatTitleFromConfig(BottomTabRouteType.BOTTOM_TAB_LOCATION),
    },
    {
        path: '/about',
        component: AboutNavigator,
        isAuthProtected: false,
        weChatTitle: 'about_upper',
    },
    {
        path: '/activity_log/:id/reach_limit',
        component: ReachLimitDetailMobile,
        isAuthProtected: true,
        weChatTitle: 'profile_activity_log',
    },
    {
        path: '/activity_log',
        component: ActivityLogMobile,
        isAuthProtected: true,
        weChatTitle: 'profile_activity_log',
    },
    {
        path: '/browser-support',
        component: BrowserNotSupport,
        isAuthProtected: false,
    },
    {
        path: '/campaign/detail',
        component: DetailRedeem,
        isAuthProtected: false,
        weChatTitle: 'campaign_detail',
    },
    {
        path: '/campaign/:id/register_success',
        component: EventRegisterResult,
        isAuthProtected: false,
        weChatTitle: 'campaign_detail',
    },
    {
        path: '/user/completed_success',
        component: NoWebappMemberAccountCompletePage,
        isAuthProtected: false,
    },
    {
        path: '/campaign/:id',
        component: CampaignDetail,
        isAuthProtected: false,
        weChatTitle: 'campaign_detail',
    },
    {
        path: '/coupon/:id/select_store',
        component: CouponSelectStore,
        isAuthProtected: true,
        weChatTitle: 'coupon_detail',
    },
    {
        path: '/coupon/:id',
        component: CouponDetail,
        isAuthProtected: true,
        weChatTitle: 'coupon_detail',
    },
    {
        path: '/ticket/:id',
        component: CouponDetail,
        isAuthProtected: true,
        weChatTitle: 'ticket_detail',
    },
    {
        path: '/inbox',
        component: Inbox,
        isAuthProtected: true,
        weChatTitle: 'home_inbox',
    },
    {
        path: '/inboxDetail/:id',
        component: InboxDetailMobile,
        isAuthProtected: true,
        weChatTitle: 'home_inbox',
    },
    {
        path: '/language',
        component: LanguagesSelection,
        isAuthProtected: false,
        weChatTitle: 'settings_language',
    },
    {
        path: '/level_benefit',
        component: LevelBenefitMobile,
        isAuthProtected: true,
        weChatTitle: 'level_benefit',
    },
    {
        path: '/level_rule',
        component: LevelRuleMobile,
        isAuthProtected: true,
        weChatTitle: 'levelRules',
    },
    {
        path: '/login_callback',
        component: Login,
        isAuthProtected: false,
    },
    {
        path: '/mobile-about',
        component: AboutMobile,
        isAuthProtected: false,
        weChatTitle: 'about',
    },
    {
        path: '/offer/:page',
        component: Offer,
        isAuthProtected: false,
        weChatTitle: getWeChatTitleFromConfig(BottomTabRouteType.BOTTOM_TAB_OFFER),
    },
    {
        path: '/reward_status',
        component: RewardStatusMobile,
        isAuthProtected: true,
        weChatTitle: 'profile_reward_status',
    },
    {
        path: '/storeDetail/:id',
        component: StoreDetail,
        isAuthProtected: false,
        weChatTitle: 'store:store_detail',
    },
    {
        path: '/transaction/create',
        component: CreateRewardClaim,
        isAuthProtected: true,
        weChatTitle: 'records:home_rewards',
    },
    {
        path: '/transaction',
        component: TransactionList,
        isAuthProtected: false,
        weChatTitle: getWeChatTitleFromConfig(BottomTabRouteType.BOTTOM_TAB_RECORDS),
    },
    {
        path: '/transactionDetail/:id',
        component: TransactionDetailMobile,
        isAuthProtected: true,
        weChatTitle: 'records:transaction_detail_title',
    },
    {
        path: '/transaction_history',
        component: TransactionHistoryListMobile,
        isAuthProtected: true,
        weChatTitle: 'profile_transaction',
    },
    {
        path: '/transaction_history_detail/:id',
        component: TransactionHistoryDetailMobile,
        isAuthProtected: true,
        weChatTitle: 'profile_transaction',
    },
    {
        path: '/use_cash_dollar',
        component: UseCashDollar,
        isAuthProtected: true,
        weChatTitle: 'cash_dollar',
    },
    {
        path: '/use_coupon',
        component: UseCoupon,
        isAuthProtected: true,
        weChatTitle: 'profile_my_coupons',
    },
    {
        path: '/user/:page',
        component: UserNavigator,
        weChatTitle: '',
    },
    {
        path: '/unsubscribe_email',
        component: UnsubscribeEmail,
        isAuthProtected: false,
    },
        {
        path: '/family_booking',
        component: EglFamilyWebview,
        isAuthProtected: false,
    },
    {
        path: '/',
        component: Login,
        isAuthProtected: false,
        exact: true,
    },
];

export const GIFT_CARD_ROUTE = {
    path: '/redeem-gift-card',
    component: RedeemGiftCard,
}

export const ABOUT_NAV_ROUTE = [
    {
        path: '/about/store',
        component: StoreList,
        weChatTitle: 'profile_store_directory',
    },
    {
        path: '/about',
        render: (props) => {
            return <Redirect to="/about/store" />;
        },
        weChatTitle: 'profile_store_directory',
    }
];

export const USER_NAV_ROUTE = [
    {
        path: '/user/myProfile',
        component: MyProfile,
        weChatTitle: getWeChatTitleFromConfig(BottomTabRouteType.BOTTOM_TAB_PROFILE),
        isAuthProtected: !detectIsMobileByScreenWidth(),
    },
    {
        path: '/user/myCard',
        component: MyCard,
        weChatTitle: 'my_card',
        isAuthProtected: true,
    },
    {
        path: '/user/myCoupon',
        render: (props) => {
            return <CouponList key="coupon" />;
        },
        weChatTitle: 'profile_my_coupons',
        isAuthProtected: true,
    },
    {
        path: '/user/myTicket',
        render: (props) => {
            return <CouponList isTicket key="ticket" />
        },
        weChatTitle: 'myTicket',
        isAuthProtected: true,
    },
    {
        path: '/user/MyAccount',
        component: MyAccount,
        weChatTitle: 'profile_my_account',
        isAuthProtected: true,
    },
    {
        path: '/user',
        render: (props) => {
            return <Redirect to="/user/myProfile" />;
        },
        weChatTitle: getWeChatTitleFromConfig(BottomTabRouteType.BOTTOM_TAB_PROFILE),
    }
];

export const OFFER_ROUTE = {
    basicPath: '/offer/',
    component: OfferList,
    weChatTitle: getWeChatTitleFromConfig(BottomTabRouteType.BOTTOM_TAB_OFFER),
}